/* eslint-disable react/forbid-elements -- This is fine */
 
import { Icon } from '@vista-digital/occ-ui'
import type { FooterPropsApi } from '../models'

export const FooterSocials = (props: FooterPropsApi) => {
    const { twitterUrl, facebookUrl, youtubeUrl, tikTokUrl, instagramUrl, linkedInUrl, socialAppsLabel } = props

    return (
        <div className="copyrights--box social-box">
            {socialAppsLabel && (<p className="copyrights--box__label">{socialAppsLabel}</p>)}
            <ul className="copyrights--social_box">
                {facebookUrl && (
                    <li>
                        <a className="social--icon social--facebook" href={facebookUrl}>
                            <Icon name="ICONOS_FACEBOOK" className="logo-image" />
                        </a>
                    </li>
                )}
                {twitterUrl && (
                    <li>
                        <a className="social--icon social--twitter" href={twitterUrl}>
                            <Icon name="ICONOS_TWITTER" className="logo-image" />
                        </a>
                    </li>
                )}
                {instagramUrl && (
                    <li>
                        <a className="social--icon social--instagram" href={instagramUrl}>
                            <Icon name="ICONOS_INSTAGRAM" className="logo-image" />
                        </a>
                    </li>
                )}
                {linkedInUrl && (
                    <li>
                        <a className="social--icon social--linkedin" href={linkedInUrl}>
                            <Icon name="ICONOS_LINKEDIN" className="logo-image" />
                        </a>
                    </li>
                )}

                {tikTokUrl && (
                    <li>
                        <a className="social--icon social--tiktok" href={tikTokUrl}>
                            <Icon name="ICONOS_TIK-TOK" className="logo-image" />
                        </a>
                    </li>
                )}

                {youtubeUrl && (
                    <li>
                        <a className="social--icon social--youtube" href={youtubeUrl}>
                            <Icon name="ICONOS_YOUTUBE" className="logo-image" />
                        </a>
                    </li>
                )}
            </ul>
        </div>
    )
}
